var OrganizationDetailsApiData = /** @class */ (function () {
    function OrganizationDetailsApiData() {
        this.spaces = [];
        this.itemTypes = [];
        this.fileUrl = "";
        this.forms = [];
        this.statuses = new Map();
        // Array<WorkItemStatus>>
        this.customFieldDefinitions = new Map();
        this.customerApps = new Map();
    }
    return OrganizationDetailsApiData;
}());
export { OrganizationDetailsApiData };
//# sourceMappingURL=organization-details-api-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/organization/organization-details-api-data.js
// module id = 886
// module chunks = 14